import { Deal } from "@Types/deal";
import { Priority } from "@Types/tickets";

import AddEmail from "../AddEmail";
import AddDescription from "../AddDescription";
import SelectLoan from "../SelectLoan/SelectLoan";
import SelectedLoan from "../SelectLoan/SelectedLoan";
import { States, TicketState, MachineStates } from "./types";
import { handleSelectValue } from "./stateMachineInteractions";

export const stateMachine: MachineStates = {
  [States.Welcome]: {
    messages: ["Welcome", "How may I assist you today? Pick an option below."],
    options: [
      { title: "I have a loan issue.", next: States.LoanIssue },
      { title: "I have an other issue.", next: States.OtherIssue },
    ],
  },
  [States.LoanIssue]: {
    messages: ["Use the search box to find the loan by VIN or customer names."],
    options: [
      {
        title: "Selected loan: ",
        next: States.LoanFound,
        component: SelectLoan,
        selectedOptionComponent: SelectedLoan,
      },

      { title: "I can't find the loan.", next: States.OtherIssue },
    ],
  },
  [States.WelcomeLoan]: {
    stateComponent: SelectedLoan,
    messages: [
      "Welcome!",
      "What sort of issue are you having with the selcted loan?",
    ],
    options: [
      {
        title: "It is a title issue",
        next: States.TitleIssue,
        onClick: handleSelectValue("isTitleIssue", true),
      },
      { title: "Other", next: States.OtherIssue },
    ],
  },
  [States.LoanFound]: {
    messages: ["Is the issue related to the title?"],
    options: [
      {
        title: "Yes, it is a title issue.",
        next: States.TitleIssue,
        onClick: handleSelectValue("isTitleIssue", true),
      },
      { title: "No. It it's something else.", next: States.OtherIssue },
    ],
  },
  [States.TitleIssue]: {
    dataName: "description",
    messages: ["Please describe your title issue."],
    options: [
      {
        title: "Describe title issue",
        next: States.Priority,
        component: AddDescription,
      },
    ],
  },

  [States.OtherIssue]: {
    messages: ["Could you provide details about the issue?"],
    dataName: "description",

    options: [
      {
        title: "Describe other issue",
        next: States.Priority,
        component: AddDescription,
      },
    ],
  },
  [States.Priority]: {
    messages: ["What is the priority level of the issue?"],
    options: [
      {
        title:
          "Low priority (low level of importance can be addressed with lower urgency)",
        onClick: handleSelectValue("priority", Priority.Low),
        next: States.Participant,
      },
      {
        title:
          "Medium Priority (a moderate level of importance, should be addressed in a timely manner)",
        onClick: handleSelectValue("priority", Priority.Medium),
        next: States.Participant,
      },
      {
        title:
          "High Priority(demands immediate attention and swift resolution due to its critical importance)",
        onClick: handleSelectValue("priority", Priority.High),
        next: States.Participant,
      },
    ],
  },
  [States.Participant]: {
    messages: ["Would you like anyone else to receive updates?"],
    dataName: "participant",
    options: [
      {
        title: "Add participant",
        next: States.Submit,
        component: AddEmail,
      },
      {
        title: "No",
        next: States.Submit,
      },
    ],
  },

  [States.Submit]: {
    messages: [
      "You are almost there! Sumbit the application or start from the beginning. ",
    ],
    options: [{ title: "Submit", next: States.End, type: "submit" }],
  },
  [States.End]: {
    messages: [
      "Thanks for submitting an issue. A team member will soon review it.",
    ],
    options: [{ title: "Submit another issue", next: States.Welcome }],
  },
};

export const initialTicketState: TicketState = {
  type: "dashboard",
  ticketData: {
    files: [],
    deal: null,
    priority: null,
    description: null,
    participant: null,
    isTitleIssue: false,
  },
  ...stateMachine[States.Welcome],
  name: States.Welcome,
  inProgress: false,
};

export const initialLoanTicketState = (deal: Deal): TicketState => ({
  type: "deal",
  ticketData: {
    deal,
    files: [],
    priority: null,
    description: null,
    participant: null,
    isTitleIssue: false,
  },
  ...stateMachine[States.WelcomeLoan],
  name: States.WelcomeLoan,
  inProgress: false,
});
